import { useState, useEffect } from "react";
import { RedriveRequestItem } from "../../../types/common";
import { Stage } from "../../../lusca-search-api/generated-src";
import { RedriveKind } from "../redriveKinds";

export const useRedriveData = (selectedStage: Stage, kind: RedriveKind) => {
  const [pastRedrives, setPastRedrives] = useState<RedriveRequestItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const fetchRedrives = async () => {
      try {
        setLoading(true);
        setError("");

        const executions = await kind.listExecutions(selectedStage);
        setPastRedrives(
          executions.map(
            (execution) =>
              ({
                executionId: execution.executionId,
                stage: execution.stage,
                user: execution.user,
                itemCount:
                  execution.count != null ? execution.count.toString() : "",
                status: execution.status ?? "",
                executor: execution.executor,
                executionDate: new Date(
                  execution.timestamp ? execution.timestamp * 1000 : 0
                ).toISOString(),
              } as RedriveRequestItem)
          )
        );
      } catch (error) {
        console.error("Error fetching redrives:", error);
        setError("Failed to load redrive history");
        setPastRedrives([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedStage) {
      fetchRedrives();
    }
  }, [selectedStage, kind]);

  return { pastRedrives, loading, error };
};
